import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: theme.spacing(6),
    },
    errorBox: {
      backgroundColor: theme.palette.error.light,
      color: theme.palette.error.contrastText,
      padding: theme.spacing(2),
      borderRadius: theme.shape.borderRadius,
      marginBottom: theme.spacing(2),
    },
  })
);

interface ErrorViewProps {
  title?: string;
  error: string;
  helpText?: string;
}

export function ErrorView({ title = 'An Error Occurred', error, helpText }: ErrorViewProps) {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Typography variant='h6' gutterBottom color='error'>
        {title}
      </Typography>
      <Box className={classes.errorBox}>
        <Typography variant='body2'>{error}</Typography>
      </Box>
      {helpText && (
        <Typography variant='body2' color='textSecondary'>
          {helpText}
        </Typography>
      )}
    </Box>
  );
}
